import { useId } from 'react';
import { StyledContainer, StyledWrapper } from './AppConnectWiresStatus.styled';

const AppConnectWiresStatus = ({ status }: { status: boolean[] }) => {
	const id = useId();

	return (
		<StyledContainer>
			{status.map((item, index) => (
				<StyledWrapper key={index}>
					<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
						<g filter={`url(#filter0_d_${id}_${index})`}>
							<circle
								cx="11"
								cy="11"
								r="5"
								fill={item ? '#44FF00' : '#FF0000'}
							/>
							<circle
								cx="11"
								cy="11"
								r="4.5"
								stroke={`url(#paint0_linear_${id}_${index})`}
								strokeOpacity="0.5"
							/>
						</g>
						<defs>
							<filter
								id={`filter0_d_${id}_${index}`}
								x="0"
								y="0"
								width="22"
								height="22"
								filterUnits="userSpaceOnUse"
								colorInterpolationFilters="sRGB"
							>
								<feFlood floodOpacity="0" result="BackgroundImageFix" />
								<feColorMatrix
									in="SourceAlpha"
									type="matrix"
									values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									result="hardAlpha"
								/>
								<feOffset />
								<feGaussianBlur stdDeviation="3" />
								<feComposite in2="hardAlpha" operator="out" />
								<feColorMatrix
									type="matrix"
									values="0 0 0 0 0.266667 0 0 0 0 1 0 0 0 0 0 0 0 0 0.75 0"
								/>
								<feBlend
									mode="normal"
									in2="BackgroundImageFix"
									result={`effect1_dropShadow_${id}_${index}`}
								/>
								<feBlend
									mode="normal"
									in="SourceGraphic"
									in2={`effect1_dropShadow_${id}_${index}`}
									result="shape"
								/>
							</filter>
							<linearGradient
								id={`paint0_linear_${id}_${index}`}
								x1="11"
								y1="6"
								x2="11"
								y2="16"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="white" />
								<stop offset="1" stopColor="white" stopOpacity="0" />
							</linearGradient>
						</defs>
					</svg>
				</StyledWrapper>
			))}
		</StyledContainer>
	);
};

export { AppConnectWiresStatus };
